import { render, staticRenderFns } from "./ModifyService.vue?vue&type=template&id=82ec4860"
import script from "./ModifyService.vue?vue&type=script&lang=js"
export * from "./ModifyService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports